import styled from 'styled-components';
import { colors, font, radius } from '../../styles/theme/tokens';

export const ImageUploaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ImageGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
`;

export const ImagePreview = styled.div`
  position: relative;
  width: 112px;
  height: 112px;
  border-radius: ${radius.md};
  overflow: hidden;
  border: 1px solid ${colors.line};

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const RemoveButton = styled.button`
  position: absolute;
  top: 6px;
  right: 6px;
  display: grid;
  place-items: center;
  width: 26px;
  height: 26px;
  border-radius: ${radius.pill};
  font-size: 16px;
  line-height: 1;
  color: #FFFFFF;
  background: rgba(30, 27, 58, 0.65);
  cursor: pointer;

  &:hover {
    background: ${colors.danger};
  }
`;

export const AddImageButton = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  width: 112px;
  height: 112px;
  border-radius: ${radius.md};
  border: 2px dashed ${colors.line};
  background: ${colors.bg};
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease;

  &:hover {
    border-color: ${colors.brand};
    background: ${colors.brandSoft};
  }

  span {
    font-size: 28px;
    font-weight: 500;
    line-height: 1;
    color: ${colors.brand};
  }

  p {
    font-family: ${font.text};
    font-size: 13px;
    font-weight: 700;
    color: ${colors.brandDeep};
    text-align: center;
  }
`;

export const HiddenInput = styled.input`
  display: none;
`;

export const InfoText = styled.p`
  font-family: ${font.text};
  font-size: 13px;
  font-weight: 500;
  color: ${colors.muted};
`;
